(function() {
  'use strict';
  angular.module('general')
  .component('versionChecker', {
    controller: ['watchForVersionChange', '$window', '$scope', function(watchForVersionChange, $window, $scope) {
      var self = this;
      self.$onInit = function onInit() {
        let msg = 'A new version of this application has been deployed. ' + 
        'We apologize for the inconvenience but the page will be reloaded.';
        watchForVersionChange().then(() => {
          $scope.dnConfirmationMessage && 
            $scope.dnConfirmationMessage.$show(msg, 'warning', 6000)
            .then(() => {
              $window.location.reload();
            });
        });
      };
    }],
    template: '<div dn-confirmation-message></div>'
  });
})();
